import { Button, Input, Space, Table, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import execute from "../requests/frappe";
import { useSelector } from "react-redux";
import { selectUser } from "../state/features/userSlice";
import { useNavigate } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";

interface DataType {
  key: React.Key;
  name: string;
  age: number;
  address: string;
}

// type DataIndex = keyof DataType;

export const Report = () => {
  const user = useSelector(selectUser);
  const isLoggedIn = !!user;
  const navigate = useNavigate();
  const [datasource, setData] = useState<any>([]);
  const [options, setOptions] = useState<any>([]);

  const [change, setChange] = useState<boolean>(false);
  const [serviceFilter, setserviceFilter] = useState<String>("");
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys: any, confirm: any, dataIndex: any) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters: any) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex: any, placeholder: any) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }: any) => (
      <div style={{ padding: "8px" }}>
        <Input
          ref={searchInput}
          placeholder={placeholder}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />

        <Space style={{ display: "Flex", justifyContent: "space-between" }}>
          <Button
            // type="B"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: any) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),

    onFilter: (value: any, record: any) => {
      const dataIndexValue = record[dataIndex];
      if (dataIndexValue !== null && dataIndexValue !== undefined) {
        return dataIndexValue
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      }
      return false; // or handle this case according to your requirements
    },
    onFilterDropdownVisibleChange: (visible: any) => {
      if (visible) {
        // setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const structure_data = (data: any) => {
    return data?.map((item: any) => ({
      full_name: item.full_name,
      uac: item.uac,
      region: item.region,
      sector: item.sector,
      company: item.company,
      app_result: item.app_result,
      sub_on: moment(item.sub_on).format("DD MMM YYYY [at] hh:mm A"),
    }));
  };

  const Fetch_Data = async () => {
    const temp_data =
      user &&
      (await execute("SERVICE_REPORT", {
        service: serviceFilter,
        // "Construction Permit by the Addis Ababa City Administration with step forms test",
      }));

    setData(structure_data(temp_data));
  };

  const Fetch_Service_list = async () => {
    const temp_data =
      user &&
      (await execute("SERVICE_LIST", {
        user: user?.email,
      }));

    setData(structure_data(temp_data));
  };

  useEffect(() => {
    setChange(true);
    if (datasource === "" || datasource === null || change) {
      Fetch_Data();
      setChange(false);
    }
  }, [serviceFilter, datasource, user]);

  const columns: any = [
    {
      title: "Full Name",
      dataIndex: "full_name",
      width: "20%",
      ...getColumnSearchProps("full_name", "Name"),
    },
    {
      title: "UAC",
      dataIndex: "uac",
      width: "10%",
      ...getColumnSearchProps("uac", "UAC"),
    },
    {
      title: "Region",
      dataIndex: "region",
      width: "10%",
      ...getColumnSearchProps("region", "Region"),
    },
    {
      title: "Sector",
      dataIndex: "sector",
      width: "10%",
      ...getColumnSearchProps("sector", "Sector"),
    },
    {
      title: "Service Provider",
      dataIndex: "company",
      width: "10%",
      ...getColumnSearchProps("company", "Service Provider"),
    },
    {
      title: "Status",
      dataIndex: "app_result",
      width: "10%",
      ...getColumnSearchProps("app_result", "Status"),
    },
    {
      title: "Submission Date",
      dataIndex: "sub_on",
      width: "10%",
      sorter: (a: any, b: any) => a.sub_on - b.sub_on,
      ...getColumnSearchProps("app_result", "Status"),

      // ...getColumnSearchProps("uac", "UAC"),
    },
  ];

  const onChange: any["onChange"] = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: any
  ) => {
    // console.log("params", pagination, filters, sorter, extra);
  };

  const onDropDownChange = () => {};

  return (
    <>
      <h1 className="text-[20px]">Service Level Report</h1>
      {isLoggedIn && datasource.length > 0 && (
        <div>
          <Select
            style={{ width: 120 }}
            // value={secondCity}
            onChange={onDropDownChange}
            options={options}
          />
          <div>
            <Table
              columns={columns}
              dataSource={datasource}
              onChange={onChange}
            />
          </div>
        </div>
      )}
    </>
  );
};
